<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                {{ form.id === '' ? 'Tambah' : 'Ubah' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Nama Unit" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama Unit
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Badan Pengelolaan Keuangan"

                      hide-details

                      v-model="form.title"
                      :success="form.title !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.title !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Kode Unit" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kode Unit
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Kode Unit"

                      hide-details

                      v-model="form.code"
                      :success="form.code !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.code !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="Asisten"
                    rules="required"  
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Asisten
                    </div>

                    <v-select
                      v-on:keyup.enter="save()"

                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Asisten Perekonomian dan Pembangunan"

                      hide-details

                      :items="[
                        'Asisten Pemerintahan dan Kesejahteraan Rakyat',
                        'Asisten Perekonomian dan Pembangunan',
                        'Asisten Administrasi Umum'
                      ]"
                      :item-color="set_color"

                      v-model="form.asisten"
                      :success="form.asisten !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.asisten !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Kepala Unit" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Kepala Unit
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Kepala Unit"

                      hide-details

                      v-model="form.head"
                      :success="form.head !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.head !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="NIP Kepala Unit" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      NIP Kepala Unit
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="NIP Kepala Unit"

                      hide-details

                      v-model="form.head_nip"
                      :success="form.head_nip !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.head_nip !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Pangkat Kepala Unit" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Pangkat Kepala Unit
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Pangkat Kepala Unit"

                      hide-details

                      v-model="form.head_grade"
                      :success="form.head_grade !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.head_grade !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>


                  <ValidationProvider
                    name="Jabatan" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Jabatan
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Jabatan Kepala Unit"

                      hide-details
                      :items="[
                        {
                          name: 'Definitif',
                          value: 'Definitif'
                        },
                        {
                          name: 'Plt',
                          value: 'Plt'
                        }
                      ]"
                      item-text="name"
                      item-value="value"

                      v-model="form.head_position"
                      :success="form.head_position !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.head_position !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Nama PIC" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Nama PIC
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Nama PIC"

                      hide-details

                      v-model="form.pic_name"
                      :success="form.pic_name !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.pic_name !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="No WA PIC" 
                    rules="required|min:10|max:13" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      No WA PIC
                    </div>

                    <v-text-field
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="No WA PIC"

                      hide-details
                      onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                      type="number"
                      min="0"
                      prefix="+62"

                      v-model="form.pic_wa_number"
                      :success="form.pic_wa_number !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-3"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.pic_wa_number !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.realisasiAll"
          @keydown.esc="dialog.realisasiAll = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Ubah Realisasi Semua Unit
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.realisasiAll = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Pilih Bulan" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Pilih Bulan
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="saveRealisasiAll()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Januari"

                      hide-details
                      :items="months"
                      item-text="text"
                      item-value="value"

                      v-model="mount_selcted"
                      :success="mount_selcted !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="mount_selcted !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider 
                    name="Pilih Status Input Realisasi"
                    rules="required"  
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>

                      Pilih Status Input Realisasi
                    </div>

                    <v-select
                      v-on:keyup.enter="saveRealisasiAll()"

                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Status Input Realisasi"

                      hide-details

                      :items="[
                        {
                          id: '1',
                          text: 'Buka'
                        },
                        {
                          id: '0',
                          text: 'Tutup'
                        }
                      ]"
                      :item-color="set_color"
                      item-text="text"
                      item-value="id"

                      v-model="is_edit"
                      :success="is_edit !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-3"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="is_edit !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-select>
                  </ValidationProvider>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="saveRealisasiAll()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.realisasiAll = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.realisasi"
          @keydown.esc="dialog.realisasi = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Ubah Realisasi
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.realisasi = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-2">
              <div>
                <div>
                  <div class="body-1 mb-2">
                    <div class="caption">
                      Nama Unit
                    </div>
                    <div class="font-weight-bold">
                      {{ form.title }}
                    </div>
                  </div>
                  <div>
                    Keterangan:
                  </div>
                  <div>
                    <v-icon size="18" color="primary">mdi-checkbox-marked</v-icon> --> <span>OPD Bisa Mengubah Realisasi</span>
                  </div>
                  <div>
                    <v-icon size="18" color="">mdi-checkbox-blank-outline</v-icon> --> <span>OPD Tidak Bisa Mengubah Realisasi</span>
                  </div>

                </div>
                <!-- <v-divider 
                  class="mb-2"
                  style="border-top: 2px dashed #e0e0e0;"/> -->
                <div>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="realisasi[0]"
                        label="Januari"
                        hide-details>
                      </v-checkbox>
    
                      <v-checkbox
                        v-model="realisasi[1]"
                        label="Februari"
                        hide-details>
                      </v-checkbox>
    
                      <v-checkbox
                        v-model="realisasi[2]"
                        label="Maret"
                        hide-details>
                      </v-checkbox>
    
                      <v-checkbox
                        v-model="realisasi[3]"
                        label="April"
                        hide-details>
                      </v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        v-model="realisasi[4]"
                        label="Mei"
                        hide-details>
                      </v-checkbox>
    
                      <v-checkbox
                        v-model="realisasi[5]"
                        label="Juni"
                        hide-details>
                      </v-checkbox>
    
                      <v-checkbox
                        v-model="realisasi[6]"
                        label="Juli"
                        hide-details>
                      </v-checkbox>
    
                      <v-checkbox
                        v-model="realisasi[7]"
                        label="Agustus"
                        hide-details>
                      </v-checkbox>
                    </v-col>
                    <v-col>
                      <v-checkbox
                        v-model="realisasi[8]"
                        label="September"
                        hide-details>
                      </v-checkbox>
    
                      <v-checkbox
                        v-model="realisasi[9]"
                        label="Oktober"
                        hide-details>
                      </v-checkbox>
    
                      <v-checkbox
                        v-model="realisasi[10]"
                        label="November"
                        hide-details>
                      </v-checkbox>
    
                      <v-checkbox
                        v-model="realisasi[11]"
                        label="Desember"
                        hide-details>
                      </v-checkbox>
                    </v-col>
                  </v-row>
                </div>

              </div>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="saveRealisasi()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.realisasi = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">{{ $route.meta.title }}</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="30">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/image/grip_menu.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-2"
                      style="font-weight: 600;">
                      Unit
                    </span>
                  </div>

                  <v-spacer />

                  <div class="d-flex align-center">
                    <v-btn
                      @click="dialog.realisasiAll = true; is_edit = ''; mount_selcted = '';"
                      color="indigo"
                      elevation="0"
                      class="body-2 mr-3 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600;">
                      <v-icon size="20">mdi-chart-bell-curve-cumulative</v-icon>
                      
                      <span
                        class="ml-2">
                        Realisasi
                      </span>
                    </v-btn>
                    <v-btn
                      @click="dialog.form = true; reset();"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            justify="end"
            class="pa-4 py-0 pr-1">
            <v-col
              cols="12"
              md="4"
              class="d-flex align-center">
              <v-text-field
                @click:clear="search = ''; fetch();"
                v-on:keyup.enter="fetch()"

                filled
                rounded
                dense
                single-line

                hide-details
                :color="set_color"
                placeholder="Cari data yang Anda butuhkan . . ."
                append-icon="mdi-magnify"
                clearable

                v-model="search"
                style="border-radius: 10px;">
              </v-text-field>

              <!-- FREEZE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.freeze = true">
                      <v-icon size="18">mdi-table-split-cell</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Freeze
                  </span>
                </v-tooltip>
              </div> -->

              <!-- HIDE COLUMN -->
              <!-- <div class="ml-3">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="0"
                      outlined
                      dark
                      min-width="36"
                      color="#7B7B7B"
                      class="text-capitalize px-0"
                      style="border-radius: 10px;"
                      v-bind="attrs"
                      v-on="on"
                      @click="dialog.hide = true">
                      <v-icon size="18">mdi-eye-off-outline</v-icon>
                    </v-btn>
                  </template>

                  <span>
                    Hide
                  </span>
                </v-tooltip>
              </div> -->
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '248px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAll($event)"
                  @dblclick:row="doubleClick"
                  hide-default-footer>
                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value, index }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                        
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="kominfoklaten" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="kominfoklaten" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="kominfoklaten" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="dialog.form = true; reset(index);"
                              
                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="blue"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-square-edit-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Ubah</span>
                        </v-tooltip>

                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="dialog.realisasi = true; reset(index);"
                              
                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="indigo"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-chart-bell-curve-cumulative</v-icon>
                            </v-btn>
                          </template>

                          <span>Realisasi</span>
                        </v-tooltip>

                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="toDelete(value)"

                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Hapus</span>
                        </v-tooltip>
                      </div>

                      <div v-if="header.format === 'bool'"
                        class="d-flex align-center justify-center">
                        
                      </div>

                      <div v-if="header.format === 'status'"
                        class="d-flex justify-center">
                        
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table>

                <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination"/>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          form: false,
          delete: false,
          realisasi: false,
          realisasiAll: false
        },
        
        search: '',

        selected: {
          row: [],
          freeze: [],
          delete: []
        },

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        form: {
          id: '',
          par_id: 0,
          title: '',
          latitude: null,
          longitude: null,
          website: '',
          asisten: '',
          code: '',
          head: '',
          head_nip: '',
          head_grade: '',
          head_position: 0,
          pic_name: '',
          pic_wa_number: ''
        },
        is_edit: '',
        mount_selcted: '',

        realisasi: [
          false, false, false, false, false, false, false, false, false, false, false, false
        ],

        process: {
          load: false,

          form: false,

          delete: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      months () {
        let numb = new Date().getMonth() + 1
        

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      }
    },
    mounted () {
      
    },
    methods: {
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },

      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          'title[lse]': this.search,
          year: new Date().getFullYear()
        }

        this.selected.row = []

        await get(`admin/unit/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '180px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              {
                text: 'Kode',
                width: '200px',
                value: 'code',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Unit',
                width: '350px',
                value: 'title',
                freeze: true,
                hide: false
              },
              {
                text: 'Kepala Unit',
                width: '300px',
                value: 'head',
                freeze: false,
                hide: false
              },
              {
                text: 'NIP Kepala Unit',
                width: '200px',
                value: 'head_nip',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama Pangkat Kepala Unit',
                width: '300px',
                value: 'head_grade',
                freeze: false,
                hide: false
              },
              {
                text: 'Jabatan',
                width: '200px',
                value: 'head_position',
                freeze: false,
                hide: false
              },
              {
                text: 'Nama PIC',
                width: '200px',
                value: 'pic_name',
                freeze: false,
                hide: false
              },
              {
                text: 'No Wa PIC',
                width: '200px',
                value: 'pic_wa_number',
                freeze: false,
                hide: false
              },
              {
                text: 'Asisten',
                width: '600px',
                value: 'asisten',
                freeze: false,
                hide: false
              },
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.form = {
          id: index !== undefined ? this.list[index].id : '',
          par_id: index !== undefined ? this.list[index].par_id : 0,
          title: index !== undefined ? this.list[index].title : '',
          latitude: index !== undefined ? this.list[index].latitude : null,
          longitude: index !== undefined ? this.list[index].longitude : null,
          website: index !== undefined ? this.list[index].website : '',
          asisten: index !== undefined ? this.list[index].asisten : '',
          code: index !== undefined ? this.list[index].code : '',
          head: index !== undefined ? this.list[index].head : '',
          head_nip: index !== undefined ? this.list[index].head_nip : '',
          head_grade: index !== undefined ? this.list[index].head_grade : '',
          head_position: index !== undefined ? this.list[index].head_position : 0,
          pic_name: index !== undefined ? this.list[index].pic_name : '',
          pic_wa_number: index !== undefined ? this.list[index].pic_wa_number.replace(/^0/, '').replace(/^62/, '') : ''
        }
        if (index !== undefined) {
          this.realisasi = this.list[index].unit_edit.map((item) => item === '1' ? true : false)
        }

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = true

          let url = this.form.id === '' ? 'admin/unit/add' : 'admin/unit/update'

          // SAVE TO REST API
          await post(url, {
            data: {
              id: this.form.id,
              par_id: this.form.par_id,
              title: this.form.title,
              latitude: this.form.latitude,
              longitude: this.form.longitude,
              website: this.form.website,
              asisten: this.form.asisten,
              code: this.form.code,
              head: this.form.head,
              head_nip: this.form.head_nip,
              head_grade: this.form.head_grade,
              head_position: this.form.head_position,
              pic_name: this.form.pic_name,
              pic_wa_number: `62${this.form.pic_wa_number}`
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.reset()

              this.fetch()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async saveRealisasi () {
        this.message.error = ''

        this.process.form = true
        // console.log(`${this.realisasi.map((item) => item ? '1' : '0').join(',')}`)
        // console.log(new Date().getFullYear())

        await post(`admin/unit/update_edit`, {
          data: {
            unit_id: this.form.id,
            arr_month: `${this.realisasi.map((item) => item ? '1' : '0').join(',')}`,
            tahun_anggaran: new Date().getFullYear()
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.realisasi = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      async saveRealisasiAll () {
        this.message.error = ''

        this.process.form = true
        // console.log(`${this.realisasi.map((item) => item ? '1' : '0').join(',')}`)
        // console.log(new Date().getFullYear())

        await post(`admin/unit/update_all_edit`, {
          data: {
            is_edit: this.is_edit,
            month: this.mount_selcted,
            tahun_anggaran: new Date().getFullYear()
          }
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            this.dialog.realisasiAll = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/unit/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>